import Utils from "../helpers/utils";

const dom = {}

const init = () => {
    dom.root = document.querySelector('[data-tags]');
    dom.buttons = [...dom.root.querySelectorAll('[data-tag-id]')];
    if (!dom.buttons.length) return;
    handleDisplay();
    bindEvents();
}

const handleDisplay = () => {
    dom.buttons.forEach(el => el.classList.remove('is-hidden'));
    const overflowedBtnIndex = dom.buttons.findIndex((el, i) => {
        return el.offsetLeft - el.parentElement.offsetLeft + el.offsetWidth >= el.parentElement.offsetWidth;
    });
    if (overflowedBtnIndex === -1) return;

    dom.buttons.slice(overflowedBtnIndex - 1).forEach(el => el.classList.add('is-hidden'));
    if (!dom.root.querySelector('[data-tags-toggle]')) {
        dom.root.insertAdjacentHTML('beforeEnd', `
            <button class="catalog_filters__tabs_btn tags_toggle" data-tags-toggle>
                <span class="tags_toggle__more">Ещё</span>
                <span class="tags_toggle__less">Свернуть</span>
                <svg class="icon icon--right">
                    <use xlink:href="#arrow_down"></use>
                </svg>
            </button>
        `)
}

}

const bindEvents = () => {
    dom.root.addEventListener('click', evt => {
        const btn = evt.target.closest('[data-tags-toggle]');
        if (!btn) return;
        dom.root.classList.toggle('is-expanded');
    })
    window.addEventListener('resize', Utils.debounce(handleDisplay))
}

export default {
    init
}
